import { render, staticRenderFns } from "./OfficeRoleDepartment.vue?vue&type=template&id=22eddf31&scoped=true&"
import script from "./OfficeRoleDepartment.vue?vue&type=script&lang=js&"
export * from "./OfficeRoleDepartment.vue?vue&type=script&lang=js&"
import style0 from "./OfficeRoleDepartment.vue?vue&type=style&index=0&id=22eddf31&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22eddf31",
  null
  
)

export default component.exports